var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48706 1.46159C1.10741 1.84729 0.887695 2.44779 0.887695 3.22545V30.9645C0.887695 31.7421 1.10741 32.3426 1.48706 32.7283L1.58077 32.813L17.5973 17.2753V16.9084L1.58077 1.37065L1.48706 1.46159Z",
    fill: "url(#paint0_linear_8293_5014)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9306 22.457L17.5977 17.2752V16.9083L22.9371 11.7264L23.0566 11.7939L29.3799 15.2855C31.1845 16.2764 31.1845 17.907 29.3799 18.9042L23.0566 22.3896L22.9306 22.457Z",
    fill: "url(#paint1_linear_8293_5014)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0565 22.3898L17.5976 17.092L1.4873 32.7285C2.08667 33.3399 3.06408 33.4136 4.17558 32.8022L23.0565 22.3898Z",
    fill: "url(#paint2_linear_8293_5014)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0565 11.7939L4.17558 1.38161C3.06408 0.776405 2.08667 0.850094 1.4873 1.46157L17.5976 17.0918L23.0565 11.7939Z",
    fill: "url(#paint3_linear_8293_5014)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8293_5014",
    x1: 16.1753,
    y1: 31.2533,
    x2: -4.86557,
    y2: 9.57278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8293_5014",
    x1: 31.7297,
    y1: 17.09,
    x2: 0.456647,
    y2: 17.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8293_5014",
    x1: 20.0881,
    y1: 14.212,
    x2: -8.44496,
    y2: -15.1886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8293_5014",
    x1: -2.56799,
    y1: 41.9569,
    x2: 10.1733,
    y2: 28.8284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.58120df720c591787096fff1e9861660.svg";
export { ForwardRef as ReactComponent };